<template>
    <div class="ph-webinar-main">
        <el-backtop ></el-backtop>
        <hpheader></hpheader>

        <div class="ph-webinar-container">
            <position-bar :positionNav="positionNav" >
            </position-bar>

            <h3 class="title">{{ detail.title }}</h3>
<!--            <div class="browse-and-time">-->
<!--                <span class="browse">View:0</span>-->
<!--                <span class="time">Time:2023-06-06 19:00:00</span>-->
<!--            </div>-->
            <i class="line"></i>
            <div class="content">
                <div class="poster">
                    <img :src="this.detail.poster" alt="">
                </div>
                <div class="text">
                    <p>Speaker: {{ detail.speaker }}</p>
                    <p>Language: {{ detail.language }}</p>
                    <p>Time: {{ detail.time }}</p>
                </div>
            </div>

            <div class="form">
                <h3>Webinar registration</h3>
                <div class="line"></div>

                <div class="form-container">
                    <el-form :model="form" :rules="rules" ref="ruleForm">
                        <el-form-item label="" prop="name">
                            <el-input v-model="form.name" placeholder="Name"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="mobile" >
                            <el-input v-model="form.mobile" placeholder="Telephone"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="email">
                            <el-input v-model="form.email" placeholder="E-Mail"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="country">
                            <el-select v-model="form.country" placeholder="Country">
                                <el-option v-for="(item,index) in countryList" :label="item.value" :value="index" :key="index"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="" prop="remark">
                            <el-input type="textarea" v-model="form.remark" rows="5" placeholder="Remark"></el-input>
                        </el-form-item>
                    </el-form>

                    <div class="webinar-button" style="text-align: center" @click="save('ruleForm')">
                        <el-button type="primary">Submit <i class="el-icon-right"></i></el-button>
                    </div>
                </div>

            </div>

        </div>



        <hpfooter></hpfooter>
    </div>
</template>

<script>
    import hpheader from '../../common/hpheader.vue'
    import hpfooter from '../../common/hpfooter.vue'
    import {session} from '../../storage/storage.js';
    import positionBar from '../../components/ph-position-bar.vue'
    import country from "../../api/country.js";


    export default {
        name: "ph-webinar-detail",
        data(){
            return {
                form:{
                    name:'',
                    country:'',
                    mobile:'',
                    remark:'',
                },
                rules: {
                    name: [
                        { required: true, message: 'Please enter name', trigger: 'blur' },
                        {  max: 255, trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: 'Please enter E-Mail', trigger: 'blur' },
                        {  max: 255, trigger: 'blur' }
                    ],
                    country: [
                        { required: true, message: 'Please select country', trigger: 'change' },
                    ],
                    mobile: [
                        { required: true, message: 'Please enter telephone', trigger: 'blur' },
                        {  max: 255, trigger: 'blur' }
                    ],
                },
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'Courses',
                        path:'/phcourses',
                    },
                    {
                        title:'',
                        path:''
                    }
                ],
                detail:{},
                id:0,
                countryList:[]
            }
        },
        components:{
            hpfooter,
            hpheader,
            positionBar
        },
        created(){
            this.id = this.$route.query.id

            if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.$router.push({path:'./pc-webinar-detail',query:{id:this.id}})
                return
            }

            if(!this.id){
                this.$router.push({path: 'phcourses'})
            }
            this.ress()
        },
        mounted(){
            this.getDetail()
            this.countryList = country.list()
        },
        methods:{
            resetForm(){
                this.form = {
                    id:'',
                    name:'',
                    country:'',
                    en_country:'',
                    cn_country:'',
                    mobile:'',
                    remark:'',
                    token:''
                }
            },
            ress(){
                var html = document.documentElement; //获取根元素
                var designWidth = 750; //设计稿宽度
                //html.clientWidth 视口宽度
                html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
            },
            getDetail(){
                var data = {
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    id:this.id
                }
                this.$api.get_cacdemy_courses_webinar_detail(data).then(res => {
                    this.detail = res.data
                    this.positionNav[2].title = this.detail.title
                })
            },
            save(formName){

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.form.channel_id = session.get('channel_id')
                        this.form.lang = session.get("lang") == '' ? 'cn' : session.get("lang")
                        this.form.id = this.detail.id
                        this.form.en_country = this.countryList[this.form.country].value
                        this.form.cn_country = this.countryList[this.form.country].label
                        this.$api.save_webinar_enroll(this.form).then(res => {
                            if(res.data.result){
                                this.$message({
                                    message: "SUCCESS",
                                    type: "success",
                                });
                                this.resetForm()
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
        }
    }
</script>
<style>
    .ph-webinar-main{
        background: #FAFAFA;
        padding-top: .88rem;
    }
    .ph-webinar-main .ph-position-bar {
        margin-left: 0;
        margin-right: 0;
    }
    .ph-webinar-main .ph-webinar-container {
        padding: .3rem;
        font-size: .26rem;
    }
    .ph-webinar-main .ph-webinar-container .title{
        font-size: .28rem;
        font-weight: 500;
        margin: .6rem 0 .3rem 0;
    }
    .ph-webinar-main .ph-webinar-container .browse-and-time {
        margin: .2rem 0;
    }
    .ph-webinar-main .ph-webinar-container .browse-and-time .browse {

    }
    .ph-webinar-main .ph-webinar-container .browse-and-time .time {
        margin-left: .3rem;
    }
    .line {
        display: block;
        width: 100%;
        border-bottom: 1px solid #EAEAEA;
    }
    .ph-webinar-main .ph-webinar-container .content {

    }
    .ph-webinar-main .ph-webinar-container .content .text {
        margin-top: .3rem;
    }
    .ph-webinar-main .ph-webinar-container .content .text p {
        margin-top: .3rem;
        color: #bababa;
    }
    .ph-webinar-main .ph-webinar-container .content .poster {

    }
    .ph-webinar-main .ph-webinar-container .content .poster img {
        width: 100%;
        display: block;
        border-radius: 20px;
    }


    .form {
        margin: .6rem 0 .3rem 0;
    }
    .form h3 {
        font-size: .3rem;
    }
    .form .form-container {
        margin-top: .3rem;
    }
    .form .line {
        margin-top: .3rem;
    }
    .ph-webinar-container .form .el-form-item .el-select {
        width: 100%;
    }
    .ph-webinar-main .ph-webinar-container .el-breadcrumb__item:last-child .el-breadcrumb__inner {

    }

    .ph-webinar-container .form .form-container input , .ph-webinar-container .form .form-container textarea {
        border: 0;
    }
    .form .form-container .webinar-button .el-button {
        background-color: #272727;
        color: #ffffff;
        border: 0;
        padding-left: 100px;
        padding-right: 100px;
        border-radius: 100px;
    }
</style>
<style scoped>

</style>